import { declOfNum } from "../../js/Util";
import { setFilterStickyButtonPosition } from "../../js/CatalogFilter";
import createMediaQuery from '../../../_src/js/mediaQuery.js';

const $filterContent = $('.js-filter-content');

if ($filterContent.length) {
    // Показываем плавающую кнопку Применить
    $('.js-filter-checkbox input, .js-filter-radio input').on('change', function () {


        /** check ***/
        App.document.currFilter = $(this).attr('name');
        /** check ***/


        App.lastCatalogChangedLine = $(this).closest('.filter-block__line');

        if ($('.js-sticky-filter-submit').length && App.lastCatalogChangedLine.length) {
            setFilterStickyButtonPosition(App.lastCatalogChangedLine);
        }
    });

    const $cityCheckboxes = $('.js-filter-city');
    const $cityCheckboxReset = $('.js-filter-city-reset');
    const $cityActiveBlock = $('.js-filter-city-active');
    const $citySubmit = $('.js-filter-city-submit');
    const $filterSubmit = $('.filter-submit.js-catalog-form-submit');

    $cityCheckboxes.on('change', function() {
        const $cityCheckboxesChecked = $cityCheckboxes.find('input:checked');

        if ($cityCheckboxesChecked.length > 0) {

            $citySubmit.prop('disabled', false);
            $cityCheckboxReset.prop('disabled', false);

            if ($cityCheckboxesChecked.length === 1) {
                $cityActiveBlock.text($cityCheckboxesChecked.siblings('label').text());
            } else {
                $cityActiveBlock.text(`В любом из ${$cityCheckboxesChecked.length} ${declOfNum($cityCheckboxesChecked.length, ['города', 'городов', 'городов'])}`);
            }
        } else {
            $cityCheckboxReset.prop('disabled', true);
            $cityActiveBlock.text(`В любом из ${$cityCheckboxes.length} ${declOfNum($cityCheckboxes.length, ['города', 'городов', 'городов'])}`);
        }
    });

    $cityCheckboxReset.on('click', function(e) {
        e.preventDefault();
        $cityCheckboxes.find('input').prop('checked', false);
        $citySubmit.prop('disabled', true);
        $cityCheckboxReset.prop('disabled', true);
        $cityActiveBlock.text(`В любом из ${$cityCheckboxes.length} ${declOfNum($cityCheckboxes.length, ['города', 'городов', 'городов'])}`);
    });

    $citySubmit.on('click', function(e) {
        e.preventDefault();
        $citySubmit.prop('disabled', true);
        $cityCheckboxReset.prop('disabled', true);
        $filterSubmit.click();
    });
}

// Навигация по категориям и подкатегориям
const $categorySelect = $('.js-category-filter-select');
const $subcategorySelect = $('.js-subcategory-filter-select');
const $catalogActiveBlock = $('.js-filter-select-active', $categorySelect);
const $subcatalogActiveBlock = $('.js-filter-select-active', $subcategorySelect);
const filterBreakpoint = createMediaQuery(`(max-width: 1139px)`);
const initialCategory = $categorySelect.find('.js-filter-select-item.selected').data('category');
const initialSubcategory = $subcategorySelect.find('.js-filter-select-item.selected').data('category');
const $selectingCategoryLinkButton = $('.js-selecting-category-link');
const $selectingCategoryResetButton = $('.js-selecting-category-reset');
const $filterCloseButton = $('.js-filter-close');

const resetCategoryAndSubcategory = () => {
    const $activeCategory = $categorySelect
        .find('.js-filter-select-item')
        .removeClass('selected')
        .siblings()
        .filter((_, itemDom) => itemDom.dataset.category === initialCategory)
        .addClass('selected');

    const $activeSubcategory = $subcategorySelect
        .find('.js-filter-select-item')
        .removeClass('selected')
        .siblings()
        .filter((_, itemDom) => itemDom.dataset.category === initialSubcategory)
        .addClass('selected');

    $catalogActiveBlock.text($('span', $activeCategory).text());
    $subcatalogActiveBlock.text($('span', $activeSubcategory).text());
    $filterContent.removeClass('_selecting-categories');
};

const isInitialCategoriesSelected = () => {
    const isInitialCategory = $('.js-filter-select-item', $categorySelect).filter('.selected').is(`[data-category="${initialCategory}"]`);
    const isInitialSubcategory = $('.js-filter-select-item', $subcategorySelect).filter('.selected').is(`[data-category="${initialSubcategory}"]`);

    return  isInitialCategory && isInitialSubcategory;
};

if ($categorySelect.length) {
    initCategorySelect($categorySelect.get());
}

function initCategorySelect(selectDom) {
    const $root = $(selectDom);
    const $selectDropdownButton = $('.js-dropdown-button', $root);
    const $selectItems = $('.js-filter-select-item', $root);

    $selectItems.on('click', (e) => {
        $selectItems.removeClass('selected');
        $(e.currentTarget).addClass('selected');
        $catalogActiveBlock.text($('span', e.currentTarget).text());
        $selectDropdownButton.click();

        // Показываем только нужные ссылки на подкатегории
        const $subcategorySelectItems = $('.js-filter-select-item', $subcategorySelect);

        $subcategorySelectItems
            .filter(':not([data-category=all])')
            .addClass('hidden')
            .removeClass('selected')
            .filter((_, itemDom) => itemDom.dataset.category === e.currentTarget.dataset.category || e.currentTarget.dataset.category === 'all')
            .removeClass('hidden');

        $subcategorySelectItems
            .filter('[data-category=all]')
            .removeClass('hidden')
            .addClass('selected')
            .attr('href', e.currentTarget.href);

        $subcatalogActiveBlock.text($('span', $subcategorySelectItems.filter('[data-category=all]')).text());
        $selectingCategoryLinkButton.attr('href', e.currentTarget.href);

        // Если меню в сайдбаре, то не переходим сразу. Переход по кнопке "Перейти в раздел"
        if (filterBreakpoint.isTrue()) {
            e.preventDefault();

            $filterContent.toggleClass('_selecting-categories', !isInitialCategoriesSelected());
        }
    });
}

if ($subcategorySelect.length) {
    initSubcategorySelect($subcategorySelect.get());
}

function initSubcategorySelect(selectDom) {
    const $root = $(selectDom);
    const $selectDropdownButton = $('.js-dropdown-button', $root);
    const $selectItems = $('.js-filter-select-item', $root);

    $selectItems.on('click', function(e) {
        $selectItems.removeClass('selected');
        $(e.currentTarget).addClass('selected');
        $subcatalogActiveBlock.text($('span', e.currentTarget).text());
        $selectDropdownButton.click();
        $selectingCategoryLinkButton.attr('href', e.currentTarget.href);

        // Если меню в сайдбаре, то не переходим сразу. Переход по кнопке "Перейти в раздел"
        if (filterBreakpoint.isTrue()) {
            e.preventDefault();

            $filterContent.toggleClass('_selecting-categories', !isInitialCategoriesSelected());
        }
    });
}

// Восстанавливаем категорию и подкатегорию в селекте при закрытии фильтра в сайдбпаре или по кнопке reset
$selectingCategoryResetButton.add($filterCloseButton).on('click', resetCategoryAndSubcategory);

filterBreakpoint.change();
filterBreakpoint.onFalse(() => {
    resetCategoryAndSubcategory();
    $filterCloseButton.click();
});
